module.exports = __webpack_public_path__ + "img/training.a7afb45b.png";